module.exports = {
    fr: {
        title: "Déplacez-vous avec Davoyage, votre chauffeur VTC à Lyon.",
        description:"Davoyage Chauffeur Privé est une entreprise de location de voitures avec chauffeur basée à Lyon, en France. Réservation en ligne ou par téléphone 24h/24 et 7j/7.",
        hero: {
            title: "Chauffeur privé à Lyon, pour chaque occasion.",
            subtitle: "Affaires, aéroport, mariages, événements, montagne : la même exigence de ponctualité et de discrétion, à chaque trajet.",
            cta: "Demander un devis",
            phone: "06 60 26 53 36",
            whatsapp: "WhatsApp",
            whatsappLink: "https://wa.me/33660265336?text=" + encodeURIComponent("Bonjour, je souhaite un devis pour un trajet."),
            caption: "Chauffeur privé VTC à Lyon"
        },
        trust: [
            {label: "★ 5,0/5", sub: "14 avis Google", url: "https://share.google/804fLtpPyjob9xix6"},
            {label: "Atout France", sub: "EVTC069140133", url: "/blog/atout-france"},
            {label: "FFEVTC", url: "/blog/federation-francaise-des-exploitants-de-voiture-de-transport-avec-chauffeur"},
            {label: "Only Lyon", url: "/blog/only-lyon"}
        ],
        destinationsLabel: "Destinations",
        destinationsTitle: "Où que vous alliez depuis Lyon, le même chauffeur vous accompagne.",
        destinations: [
            "Aéroport Lyon-Saint-Exupéry",
            "Paris",
            "Genève",
            "Annecy",
            "Courchevel",
            "Val d'Isère",
            "Val Thorens",
            "Méribel",
            "Les Arcs",
            "Alpe d'Huez",
            "Megève",
            "Route des Vins de Bourgogne",
            "Grenoble",
            "Chambéry",
            "…"
        ],
        closing: {
            title: "Votre prochain trajet mérite ce soin.",
            cta: "Demander un devis",
            phone: "06 60 26 53 36",
            whatsapp: "WhatsApp",
            whatsappLink: "https://wa.me/33660265336?text=" + encodeURIComponent("Bonjour, je souhaite un devis pour un trajet.")
        }
    },
    en: {
        title: "Ride with Davoyage, your private driver in France.",
        description:"Davoyage Private Driver is a car rental with driver company based in Lyon, France.",
        hero: {
            title: "Private driver in Lyon, for every occasion.",
            subtitle: "Business, airport, weddings, events, mountain transfers: the same punctuality and discretion, every trip.",
            cta: "Request a quote",
            phone: "+33 6 60 26 53 36",
            whatsapp: "WhatsApp",
            whatsappLink: "https://wa.me/33660265336?text=" + encodeURIComponent("Hello, I'd like a quote for a ride."),
            caption: "Private chauffeur VTC in Lyon"
        },
        trust: [
            {label: "★ 5.0/5", sub: "14 Google reviews", url: "https://share.google/804fLtpPyjob9xix6"},
            {label: "Atout France", sub: "EVTC069140133", url: "/en/blog/atout-france"},
            {label: "FFEVTC", url: "/en/blog/discover-the-french-federation-of-private-passenger-transport-companies-ffevtc"},
            {label: "Only Lyon", url: "/en/blog/only-lyon"}
        ],
        destinationsLabel: "Destinations",
        destinationsTitle: "From Lyon, with the same driver all the way.",
        destinations: [
            "Lyon-Saint-Exupéry Airport",
            "Paris",
            "Geneva",
            "Annecy",
            "Courchevel",
            "Val d'Isère",
            "Val Thorens",
            "Méribel",
            "Les Arcs",
            "Alpe d'Huez",
            "Megève",
            "Burgundy Wine Route",
            "Grenoble",
            "Chambéry",
            "…"
        ],
        closing: {
            title: "Your next trip deserves this much care.",
            cta: "Request a quote",
            phone: "+33 6 60 26 53 36",
            whatsapp: "WhatsApp",
            whatsappLink: "https://wa.me/33660265336?text=" + encodeURIComponent("Hello, I'd like a quote for a ride.")
        }
    },
    ru: {
        title: "Поездка с Davoyage, вашим личным водителем во Франции.",
        description:"Davoyage Private Driver - это прокат автомобилей с компанией-водителем в Лионе, Франция.",
        hero: {
            title: "Личный водитель на любой случай, в Лионе и за его пределами.",
            subtitle: "Деловые поездки, трансферы из аэропорта, свадьбы, мероприятия или поездки в Альпы — всегда с одинаковой деликатностью и вниманием.",
            cta: "Запросить расчёт",
            phone: "+33 6 60 26 53 36",
            whatsapp: "WhatsApp",
            whatsappLink: "https://wa.me/33660265336?text=" + encodeURIComponent("Здравствуйте, хочу запросить расчёт поездки."),
            caption: "Личный водитель VTC в Лионе"
        },
        trust: [
            {label: "★ 5.0/5", sub: "14 отзывов Google", url: "https://share.google/804fLtpPyjob9xix6"},
            {label: "Atout France", sub: "EVTC069140133", url: "/ru/blog/atout-france"},
            {label: "FFEVTC", url: "/ru/blog/frantsuzskaya-federatsiya-perevozchikov-naemnykh-transportnykh-sredstv-ffevtc"},
            {label: "Only Lyon", url: "/ru/blog/only-lyon"}
        ],
        destinationsLabel: "Направления",
        destinationsTitle: "Из Лиона, с одним и тем же водителем.",
        destinations: [
            "Аэропорт Лион-Сент-Экзюпери",
            "Париж",
            "Женева",
            "Анси",
            "Куршевель",
            "Валь-д'Изер",
            "Валь-Торанс",
            "Мерибель",
            "Лез-Арк",
            "Альп-д'Юэз",
            "Межев",
            "Винная дорога Бургундии",
            "Гренобль",
            "Шамбери",
            "…"
        ],
        closing: {
            title: "Ваша следующая поездка заслуживает такого внимания.",
            cta: "Запросить расчёт",
            phone: "+33 6 60 26 53 36",
            whatsapp: "WhatsApp",
            whatsappLink: "https://wa.me/33660265336?text=" + encodeURIComponent("Здравствуйте, хочу запросить расчёт поездки.")
        }
    },
    de: {
        title: "Unterwegs mit Davoyage, Ihrem Privatchauffeur in Lyon.",
        description: "Davoyage ist Ihr Privatchauffeur in Lyon: Transfers zu Flughäfen und Bahnhöfen, in die Skiorte und Weinregionen, Geschäftsreisen. Buchung online oder telefonisch, rund um die Uhr.",
        hero: {
            title: "Privatchauffeur in Lyon, für jeden Anlass.",
            subtitle: "Geschäftsreisen, Flughafen, Hochzeiten, Veranstaltungen, Bergtransfers: dieselbe Pünktlichkeit und Diskretion bei jeder Fahrt.",
            cta: "Angebot anfordern",
            phone: "+33 6 60 26 53 36",
            whatsapp: "WhatsApp",
            whatsappLink: "https://wa.me/33660265336?text=" + encodeURIComponent("Guten Tag, ich möchte ein Angebot für eine Fahrt."),
            caption: "Privatchauffeur in Lyon"
        },
        trust: [
            {
                label: "★ 5.0/5",
                sub: "14 Google-Bewertungen",
                url: "https://share.google/804fLtpPyjob9xix6"
            },
            {
                label: "Atout France",
                sub: "EVTC069140133",
                url: "/de/blog/atout-france"
            },
            {
                label: "FFEVTC",
                url: "/de/blog/franzoesischer-verband-evtc-ffevtc"
            },
            {
                label: "Only Lyon",
                url: "/de/blog/only-lyon"
            }
        ],
        destinationsLabel: "Ziele",
        destinationsTitle: "Ab Lyon, mit demselben Chauffeur bis ans Ziel.",
        destinations: [
            "Flughafen Lyon-Saint-Exupéry",
            "Paris",
            "Genf",
            "Annecy",
            "Courchevel",
            "Val d'Isère",
            "Val Thorens",
            "Méribel",
            "Les Arcs",
            "Alpe d'Huez",
            "Megève",
            "Burgundische Weinstraße",
            "Grenoble",
            "Chambéry",
            "…"
        ],
        closing: {
            title: "Ihre nächste Fahrt verdient diese Sorgfalt.",
            cta: "Angebot anfordern",
            phone: "+33 6 60 26 53 36",
            whatsapp: "WhatsApp",
            whatsappLink: "https://wa.me/33660265336?text=" + encodeURIComponent("Guten Tag, ich möchte ein Angebot für eine Fahrt.")
        }
    },
    it: {
        title: "Viaggia con Davoyage, il tuo autista privato a Lione.",
        description: "Davoyage è il tuo autista privato (NCC) a Lione: transfer da aeroporti e stazioni, verso le stazioni sciistiche e i vigneti, viaggi d'affari. Prenotazione online o per telefono, 24 ore su 24.",
        hero: {
            title: "Autista privato a Lione, per ogni occasione.",
            subtitle: "Affari, aeroporto, matrimoni, eventi, montagna: la stessa puntualità e discrezione, a ogni viaggio.",
            cta: "Richiedi un preventivo",
            phone: "+33 6 60 26 53 36",
            whatsapp: "WhatsApp",
            whatsappLink: "https://wa.me/33660265336?text=" + encodeURIComponent("Buongiorno, vorrei un preventivo per un viaggio."),
            caption: "Autista privato NCC a Lione"
        },
        trust: [
            {
                label: "★ 5.0/5",
                sub: "14 recensioni Google",
                url: "https://share.google/804fLtpPyjob9xix6"
            },
            {
                label: "Atout France",
                sub: "EVTC069140133",
                url: "/it/blog/atout-france"
            },
            {
                label: "FFEVTC",
                url: "/it/blog/federazione-francese-ncc-ffevtc"
            },
            {
                label: "Only Lyon",
                url: "/it/blog/only-lyon"
            }
        ],
        destinationsLabel: "Destinazioni",
        destinationsTitle: "Da Lione, con lo stesso autista per tutto il viaggio.",
        destinations: [
            "Aeroporto di Lione-Saint-Exupéry",
            "Parigi",
            "Ginevra",
            "Annecy",
            "Courchevel",
            "Val d'Isère",
            "Val Thorens",
            "Méribel",
            "Les Arcs",
            "Alpe d'Huez",
            "Megève",
            "Strada dei vini di Borgogna",
            "Grenoble",
            "Chambéry",
            "…"
        ],
        closing: {
            title: "Il tuo prossimo viaggio merita questa cura.",
            cta: "Richiedi un preventivo",
            phone: "+33 6 60 26 53 36",
            whatsapp: "WhatsApp",
            whatsappLink: "https://wa.me/33660265336?text=" + encodeURIComponent("Buongiorno, vorrei un preventivo per un viaggio.")
        }
    },
    es: {
        title: "Viaje con Davoyage, su chófer privado en Lyon.",
        description: "Davoyage es su chófer privado (VTC) en Lyon: traslados a aeropuertos y estaciones de tren, a las estaciones de esquí y a los viñedos, viajes de negocios. Reserva en línea o por teléfono, las 24 horas.",
        hero: {
            title: "Chófer privado en Lyon, para cada ocasión.",
            subtitle: "Negocios, aeropuerto, bodas, eventos, montaña: la misma puntualidad y discreción en cada trayecto.",
            cta: "Solicitar un presupuesto",
            phone: "+33 6 60 26 53 36",
            whatsapp: "WhatsApp",
            whatsappLink: "https://wa.me/33660265336?text=" + encodeURIComponent("Hola, quisiera un presupuesto para un trayecto."),
            caption: "Chófer privado VTC en Lyon"
        },
        trust: [
            {
                label: "★ 5.0/5",
                sub: "14 reseñas en Google",
                url: "https://share.google/804fLtpPyjob9xix6"
            },
            {
                label: "Atout France",
                sub: "EVTC069140133",
                url: "/es/blog/atout-france"
            },
            {
                label: "FFEVTC",
                url: "/es/blog/federacion-francesa-vtc-ffevtc"
            },
            {
                label: "Only Lyon",
                url: "/es/blog/only-lyon"
            }
        ],
        destinationsLabel: "Destinos",
        destinationsTitle: "Desde Lyon, con el mismo chófer durante todo el viaje.",
        destinations: [
            "Aeropuerto de Lyon-Saint-Exupéry",
            "París",
            "Ginebra",
            "Annecy",
            "Courchevel",
            "Val d'Isère",
            "Val Thorens",
            "Méribel",
            "Les Arcs",
            "Alpe d'Huez",
            "Megève",
            "Ruta de los vinos de Borgoña",
            "Grenoble",
            "Chambéry",
            "…"
        ],
        closing: {
            title: "Su próximo trayecto merece este cuidado.",
            cta: "Solicitar un presupuesto",
            phone: "+33 6 60 26 53 36",
            whatsapp: "WhatsApp",
            whatsappLink: "https://wa.me/33660265336?text=" + encodeURIComponent("Hola, quisiera un presupuesto para un trayecto.")
        }
    }
};